import * as CoreContextActions from './core-context-actions';
import { CoreContextActionTypes } from './core-context-actions';
import { Action } from '@ngrx/store';

export interface State {
  cookieTrackingConsent: boolean | null;
}

const initialState: State = {
  cookieTrackingConsent: null,
};

export function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case CoreContextActionTypes.SET_COOKIE_TRACKING_CONSENT: {
      return {
        ...state,
        cookieTrackingConsent: (<CoreContextActions.SetCookieTrackingConsent>action).enabled,
      };
    }
    default: { return state; }
  }
}
